
export const initialState = {
  tabManagers: {}
};

export default initialState;
